import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M18 10.352V7.648l-1.624-.656a7.607 7.607 0 0 0-.742-1.787l.685-1.614-1.911-1.911-1.614.685a7.6 7.6 0 0 0-1.786-.742L10.352 0H7.648l-.656 1.624a7.58 7.58 0 0 0-1.786.741L3.592 1.68 1.68 3.592l.685 1.614a7.58 7.58 0 0 0-.741 1.786L0 7.648v2.703l1.624.656c.167.619.416 1.218.742 1.787l-.686 1.614 1.912 1.912 1.614-.685a7.59 7.59 0 0 0 1.787.742L7.648 18h2.703l.656-1.624a7.548 7.548 0 0 0 1.787-.742l1.614.685 1.912-1.912-.685-1.614a7.59 7.59 0 0 0 .742-1.787L18 10.352zm-5-2.131a5.54 5.54 0 0 1-4 5.32 5.54 5.54 0 0 1-4-5.32V6h8v2.221z" />
  </svg>
);

export default SvgComponent;
